import { NotificationManager } from 'react-notifications';
import axios, { AxiosError } from 'axios';
import {
  IGetPayoutCommission,
  IPayoutCommission,
  IPayoutCommissionCreate,
  IPayoutCommissionToggle,
  TPayoutCommissionResponse,
} from 'src/store/api/payoutCommission/types';

const getPayoutCommissions = async (props: IGetPayoutCommission): Promise<TPayoutCommissionResponse | undefined> => {
  const { data, params } = props;
  try {
    const res = await axios.post(`/api/v1/payout/commissions/filter`, data, { params });
    return res.data;
  } catch (e) {
    NotificationManager.error('Fetch commissions error');
  }
};

const getPayoutCommission = async (commissionId: number): Promise<IPayoutCommission | undefined> => {
  try {
    const res = await axios.get(`/api/v1/payout/commissions/${commissionId}`);
    return res.data;
  } catch (e) {
    NotificationManager.error('Fetch commission error');
  }
};

const createPayoutCommission = async (data: IPayoutCommissionCreate): Promise<IPayoutCommission | undefined> => {
  try {
    const res = await axios.post(`/api/v1/payout/commissions`, data);
    return res.data;
  } catch (err) {
    const errors = err as AxiosError<{ message: string }>;
    if (axios.isAxiosError(errors) && errors.response) {
      NotificationManager.error(errors.response?.data.message);
    }
  }
};

const updatePayoutCommission = async (commissionId: number, data: IPayoutCommissionCreate): Promise<IPayoutCommission | undefined> => {
  try {
    const res = await axios.put(`/api/v1/payout/commissions/${commissionId}`, data);
    return res.data;
  } catch (err) {
    const errors = err as AxiosError<{ message: string }>;
    if (axios.isAxiosError(errors) && errors.response) {
      NotificationManager.error(errors.response?.data.message);
    }
  }
};

const togglePayoutCommission = async (commissionId: number, data: IPayoutCommissionToggle): Promise<IPayoutCommission | undefined> => {
  try {
    const res = await axios.patch(`/api/v1/payout/commissions/${commissionId}/active/toggle`, data);
    return res.data;
  } catch (e) {
    NotificationManager.error('Toggle change commission error');
  }
};

export const payoutCommissionApi = {
  getPayoutCommissions,
  togglePayoutCommission,
  getPayoutCommission,
  createPayoutCommission,
  updatePayoutCommission,
};
